module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SB - Solomon Islands.09ba5e32.svg";